import SCROLL from 'constants/scrolls'
import TitleText from './title'

export default [
  {
    text: TitleText.profile,
    to: SCROLL.PROFILE,
  },
  {
    text: TitleText.research,
    to: SCROLL.RESEARCH,
  },
  {
    text: TitleText.photo,
    to: SCROLL.PHOTO,
  },
  {
    text: TitleText.history,
    to: SCROLL.HISTORY,
  },
  {
    text: TitleText.url,
    to: SCROLL.URL,
  },
]
